import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useProgressIndicatorStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalS),
    ...shorthands.padding(0, 0, tokens.spacingVerticalS, 0),
    ...shorthands.overflow('hidden'),
    transitionProperty: 'max-height, opacity, padding',
    transitionDuration: '300ms',
    transitionTimingFunction: 'ease-out',
  },
  containerExpanded: {
    maxHeight: '5000px',
    opacity: 1,
  },
  /** After streaming completes — stays visible (not collapsed to 0) */
  containerCompleted: {
    maxHeight: '5000px',
    opacity: 1,
  },
  /** Individual event message */
  eventItem: {
    ...shorthands.padding(tokens.spacingVerticalXS, tokens.spacingHorizontalS),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    backgroundColor: tokens.colorNeutralBackground3,
  },
  /** Dimmed style for completed (non-latest) events */
  eventItemCompleted: {
    opacity: 0.7,
  },
  /** Collapse/expand toggle */
  collapseToggle: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalXS),
    cursor: 'pointer',
    ':hover': {
      opacity: 0.8,
    },
  },
  collapseToggleText: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorBrandForeground1,
  },
  chevron: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    color: tokens.colorBrandForeground1,
  },
  /** Markdown-rendered EventMessage content */
  markdownContent: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground2,
    lineHeight: tokens.lineHeightBase300,
    '& h1': {
      fontSize: tokens.fontSizeBase300,
      fontWeight: tokens.fontWeightSemibold,
      ...shorthands.margin(0, 0, tokens.spacingVerticalXXS, 0),
    },
    '& h2': {
      fontSize: tokens.fontSizeBase200,
      fontWeight: tokens.fontWeightSemibold,
      ...shorthands.margin(tokens.spacingVerticalXXS, 0, tokens.spacingVerticalXXS, 0),
    },
    '& ul, & ol': {
      ...shorthands.margin(0),
      ...shorthands.padding(0, 0, 0, tokens.spacingHorizontalL),
    },
    '& li': {
      ...shorthands.margin(0, 0, tokens.spacingVerticalXXS, 0),
    },
    '& p': {
      ...shorthands.margin(0, 0, tokens.spacingVerticalXXS, 0),
    },
  },
  /** "Working on it..." label shown during streaming */
  workingLabel: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalXS),
    lineHeight: tokens.lineHeightBase200,
  },
  workingText: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    fontStyle: 'italic',
  },
});
